module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "ToggleThumbnailGroup nl1-ns nr1-ns"
  }, _vm._l((_vm.model.options), function(option, optI) {
    return (!_vm.disabledOptions.includes(option.id)) ? _c('div', {
      staticClass: "ToggleThumbnail gutter mt2 mt0-ns tc",
      class: {
        'ToggleThumbnail--selected': _vm.currentOptionIndex === optI,
          'ToggleThumbnail--disabled': _vm.disabledOptions.includes(option.id)
      }
    }, [_c('div', {
      staticClass: "cell w-100"
    }, [_c('div', {
      staticClass: "ToggleThumbnailBox",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.selectOption(option, optI)
        }
      }
    }, [_c('div', {
      staticClass: "Thumbnail aspect-ratio aspect-ratio--1x1"
    }, [_c('div', {
      staticClass: "aspect-ratio--object cover",
      style: (_vm.thumbnails[optI])
    })]), _c('div', {
      staticClass: "ToggleThumbnailInfos ph2 pv3 ph3-l pv3-l"
    }, [_c('div', {
      staticClass: "ToggleThumbnailName"
    }, [_vm._v(_vm._s(_vm._f("ratio")(option.name)))])])]), (option.description) ? _c('div', {
      staticClass: "ToggleThumbnailInfos pt1 pt2-l pb3"
    }, [_c('div', {
      staticClass: "ToggleThumbnailDescription",
      domProps: {
        "innerHTML": _vm._s(option.description)
      }
    })]) : _vm._e()])]) : _vm._e()
  }), 0), (_vm.selectedOption.customField) ? _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.selectedOption.customFieldData),
      expression: "selectedOption.customFieldData",
      modifiers: {
        "lazy": true
      }
    }],
    attrs: {
      "placeholder": _vm.selectedOption.description
    },
    domProps: {
      "value": (_vm.selectedOption.customFieldData)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.selectedOption, "customFieldData", $event.target.value)
      }
    }
  })]) : _vm._e(), (!_vm.areAllOptionsDisabled && _vm.isCurrentOptionDisabled) ? _c('p', {
    staticClass: "f6 lh-copy measure ToggleError dark-red"
  }, [_vm._v("Please select an available option")]) : _vm._e(), (_vm.isCustomFieldEmpty) ? _c('p', {
    staticClass: "f6 lh-copy measure ToggleError dark-red"
  }, [_vm._v("Please enter a description")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2206a320!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BookartCategory/BookartToggleThumbnail/BookartToggleThumbnail.vue
// module id = 186
// module chunks = 2